import { render } from "./NewOrganization.vue?vue&type=template&id=7f32ad98&ts=true"
import script from "./NewOrganization.vue?vue&type=script&lang=ts"
export * from "./NewOrganization.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__